import {Component} from '@angular/core';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-vertegenwoordiger',
    templateUrl: './vertegenwoordiger.component.html',
    styleUrls: ['./vertegenwoordiger.component.scss'],
})
export class VertegenwoordigerComponent  {}

